import { type FC } from 'react';

import { cn } from '@/lib/tw-merge/cn';

interface TypingIndicatorProps {
  agentImageSrc?: string;
  agentName?: string;
  className?: string;
}

export const TypingIndicator: FC<TypingIndicatorProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'w-fit max-w-[85%] self-start rounded-2xl rounded-tl-sm border border-gray-100 bg-white px-4 py-3 shadow-sm sm:px-5',
        className
      )}
    >
      <div className="flex items-center gap-1">
        <span className="h-2 w-2 animate-pulse rounded-full bg-gray-400 [animation-delay:0ms]" />
        <span className="h-2 w-2 animate-pulse rounded-full bg-gray-400 [animation-delay:150ms]" />
        <span className="h-2 w-2 animate-pulse rounded-full bg-gray-400 [animation-delay:300ms]" />
      </div>
    </div>
  );
};
